import ReferencePathService from '~/services/referencePathServices/referencePathService';
import {
  IReferencePathNodeSpecific,
  IReferencePathNodeObjectModelLinkedForm,
} from '~/interfaces/referencePathInterfaces';
import { ModelType } from '~/enums/modelType';
import Form from '../../../formability/form_builder/models/form';
import { GenericType } from '~/interfaces/genericTypeInterfaces';

export default class ObjectModelLinkedFormPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.Form
  referenceIsCollection = true;
  referenceIsInitializable = false;

  constructor(private linkedFormNode: IReferencePathNodeObjectModelLinkedForm) {
    super();
  }

  get label(): string {
    return this.reference()?.titleOrDefault;
  }

  get nodes(): [IReferencePathNodeObjectModelLinkedForm] {
    return [this.linkedFormNode];
  }

  reference(): Form {
    return Form.repo.findById(this.linkedFormNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('LinkedFormPathService', this.linkedFormNode, node, decision)
    return decision
  }
}